module.exports = __webpack_public_path__ + "media/images/number-heading-3cf2a2f7be736684023c7f5fca05a924.svg";